<template>
	<div class="report">
        <!-- left panel -->
        <el-col :span="5" class="report-categories">
           <div class="report-category" 
                :class="reportCategory === 0 ? 'onSetttng' : ''" @click="setCategory(0)">
                統計總覽
            </div>
            <div class="report-category" 
                :class="reportCategory === 1 ? 'onSetttng' : ''" @click="setCategory(1)">
                閱覽記錄
            </div>
            <div class="report-category" 
                :class="reportCategory === 2 ? 'onSetttng' : ''" @click="setCategory(2)"
                v-if="this.$store.state.isSystemAdminMode">
                批次匯出閱覽記錄
            </div>
        </el-col>
        <!-- right panel -->
        <el-col :span="19">
            <div class="report-title">
                <div>
                    <div v-if="$store.state.report.isShowPersonalDetail && (reportCategory === 1)"
                     @click="resetPersonalDetail()" class="text-link">
                        {{ categoryTitle }} 
                    </div>
                    <div v-else>
                        {{ categoryTitle }} 
                    </div>
                </div>
                <div v-if="reportCategory === 1" style="margin-right: auto">
                    <div v-if="$store.state.report.isShowPersonalDetail">
                       &nbsp;>&nbsp; {{ this.$store.state.report.personalListStatus.name }}&nbsp;({{ this.$store.state.report.personalListStatus.id }})
                    </div>
                    <el-cascader v-else v-show="$store.state.isSystemAdminMode" placeholder="" class="menu-select"
							v-model="$store.state.report.selectedDepId"
							:show-all-levels="false"
    						:options="actualDepsOptions"
							@change="handleActualDepSelect">
			        </el-cascader>
                </div>
                <div>
                     <el-date-picker
                        style="width:230px;"
                        v-model="$store.state.report.dateRange"
                        type="daterange"
                        align="right"
                        placeholder="選擇日期範圍"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
            </div>
            <div class="report-content">
                <el-row v-if="reportCategory === 0">
                    <ReportOverview></ReportOverview>
                </el-row>
                <el-row v-else-if="reportCategory === 1">
                    <ReportDetail></ReportDetail>
                </el-row>
                <el-row v-else-if="reportCategory === 2">
                    <ReportDetailExport @searchHint="showHint"></ReportDetailExport>
                </el-row>
            </div>
        </el-col>
        <hint v-show="hint.display && this.$store.state.hintStatus.report" 
			:message="hint.message" @close="closeHint">
		</hint>
    </div>
</template>
<script>
import { DepartmentModel } from '@/common/js/data';
import ReportOverview from './ReportOverview';
import ReportDetail from './ReportDetail';
import ReportDetailExport from './ReportDetailExport';
export default {
    name: 'Report',
    components: { 
        ReportOverview,
        ReportDetail,
        ReportDetailExport,
    },
    data() {
        return {
            reportCategory: -1,
            categoryTitle: "",
            actualDepsOptions: [],
            baseDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.baseDate = minDate.getTime();
                    if (maxDate) {
                        this.baseDate = '';
                    }
                    if (maxDate && minDate) {
                        this.dateRange = [minDate.getTime(), maxDate.setHours(23,59,59,999)];
                    }
                },
                disabledDate: (time) => {
                    let choiceDateTime = new Date(this.baseDate).getTime();
                    const minTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth());
                    const maxTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() + 3);
                    const min = minTime;
                    const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
                    const max = newDate < maxTime ? newDate : maxTime;
                    if (this.baseDate) {
                        return time.getTime() < min || time.getTime() > max;
                    }
                    return time.getTime() > newDate;
                }
            },
            hint: {
				message: '',
				display: false,
			},
            timer: null,
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.initial();
                }
            }
        }
    },
    created() {
        this.$store.state.nowStatus = 13;
    },
    methods: {
        async initial() {
            if(this.$store.state.isBackendMode) {
                // init actualDepsOptions
                let departmentModel = new DepartmentModel();
                this.actualDepsOptions = await departmentModel.getActualDepsOptions();

                if (this.$store.state.entrance === "personalReport" && 
                this.$store.state.report.dateRange && this.$store.state.report.selectedDepId) {
                    this.setCategory(1);
                } else {
                    // actualDep default
                    if (this.$store.state.isSystemAdminMode) {
                        this.$store.state.report.selectedDepId = [this.actualDepsOptions[0].value, this.actualDepsOptions[0].children[0].value]
                    } else {
                        this.$store.state.report.selectedDepId = [this.$store.state.userDepId, this.$store.state.userActualDepId];
                    }

                    // datepicker default
                    let start = new Date().setHours(0,0,0,0)- 3600 * 1000 * 24 * 6;
                    let end = new Date().setHours(23,59,59,999);
                    this.$store.state.report.dateRange = [start, end];

                    this.setCategory(0);
                }
            } else {
                this.$router.push({ path: '/table' });
            }
        },
        setCategory: function(index) {
            this.reportCategory = index;
            switch (index) {
                case 0:
                    this.categoryTitle = "統計總覽";
                    this.resetDetailList();
                    this.resetPersonalDetail();
                    break;
                case 1:
                    this.categoryTitle = "閱覽記錄";
                    break;
                case 2:
                    this.categoryTitle = "批次匯出閱覽記錄";
                    break;
                default:
                    break;
            }
        },
        handleActualDepSelect: function(key) {
            console.log("report selectedDepId");
            console.log(key);
        },
        resetDetailList() {
            this.$store.state.report.detailListStatus.pagination.current_page = 1;
            this.$store.state.report.detailListStatus.pagination.offset = 0;
        },
        resetPersonalDetail() {
            this.$store.state.report.personalListStatus.id = null;
            this.$store.state.report.personalListStatus.name = null;
            this.$store.state.report.personalListStatus.pagination.current_page = 1;
            this.$store.state.report.personalListStatus.pagination.offset = 0;
            this.$store.state.report.isShowPersonalDetail = false;
        },
        /**
          * closeHint close hint 視窗
          * @return none
          */
        closeHint: function() {
            this.hint.display = false;
            this.$store.state.hintStatus.report = false;
            clearTimeout(this.timer);
        },
        /**
          * showHint 
          * @param  {string} message - message
          * @return none
          */
        showHint: function(message) {
            if(this.timer) {
                clearTimeout(this.timer);	
            }
            this.hint.display = true;
            this.hint.message = message;	
            this.$store.state.showHint= true;
            this.$store.state.hintStatus.report = true;
            this.timer = setTimeout(()=>{
                if(this.$store.state.showHint) {
                    this.$store.state.showHint = false;
                    this.$store.state.hintStatus.report = false;
                }
            }, this.$store.state.fadeOutTime);
        },
    },
}
</script>
<style lang="scss">
$border-color: #D5D5D4;
$border-color2: #EEEEEE;
.report {
	margin-top : 22px;

    .report-categories {
		background-color: white;
		border: $border-color2 1px solid;
    	height: 250px;
    	float: left;

        .report-category {
            line-height: 24px;
            display: inline-block;
            margin-left: 15px;	
            margin-top: 20px;
            padding-bottom: 15px;	
            border-bottom: 1px solid $border-color;
            width: 80%;
            font-size: 16px;
            color: #515151;
            cursor: pointer;
        }

        .onSetttng {
            color: #1D2327;
            font-weight: 500;
        }
    }

    .report-title {
        display: flex;
        justify-content: space-between;
        margin-left: 30px;
        color: #3C3B38;
        font-size: 24px;
        font-weight: 500;
        height: 48px;
        line-height: 48px;

        .text-link {
            text-decoration: underline;
            color: #2E90F4;
            cursor: pointer;
        }
        
        
        .menu-select {
			display: block;
			float: left;
			max-width: 18vw;
			margin-left: 20px;
			text-align: center;

            .el-cascader-menus {
                margin-top: 0px;
            }

			.el-cascader__label{
				margin-top: 9px;
			}

			.el-input__inner{
				border-color: #B6B6B6;
				background-color: white;
				border-radius: 2px;
				font-size: 14px;
				font-weight: 500;
				color: #222;
				line-height: 24px;
				margin-top: 9px;	
			}
	
			.el-input__icon{
				width: 40px;
				margin-top: 4px;
				color: #626874;
			}
		
			.el-input__suffix {
				&:before {
					content: '';
					position: absolute;
					left: 0;
					height: 32px;
					width: 1px;
					background-color: rgba(151, 151, 151, .35);
					margin-top: 7px;
				}
			}

			.el-icon-arrow-up {
				&:before {
					color: #a7a7a7;
					content: '\25B2';
				}
			}
		}
    }

    .report-content {
        margin-left: 20px;
        margin-bottom : 30px;
    }
}
</style>


// WEBPACK FOOTER //
// Report.vue?91132a14